import { getCurrentInstance, h, ref, Teleport, TransitionGroup } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import rescue from './helpers/rescue';
import uid from './helpers/uid';
import get from 'lodash/get';
import { usePage } from '@inertiajs/inertia-vue3';

const items = ref([
  //
]);

function remove(key) {
  rescue(() => {
    const index = items.value.findIndex(message => message.key === key);
    items.value.splice(index, 1);
  });
}

function handler() {
  const page = usePage();
  const message = get(page, 'props.value.flash.message');

  if (message)
    items.value.unshift({ ...message, key: uid() });
}

Inertia.on('success', handler);
Inertia.on('error', handler);

export function useMessage() {
  const instance = getCurrentInstance();
  const key = get(instance, 'vnode.props.key');

  function unmount() {
    remove(key);
  }

  return {
    remove,
    unmount,
    instance,
    items,
    key,
  };
}

export function renderMessages(component) {
  return h(
    Teleport,
    { to: '#messages' },
    h(TransitionGroup, { name: 'message' }, () => items.value.map(props => h(component, props)))
  );
}
